import {
    CAC_ADD_CUSTOM_CARD,
    CAC_ADD_TO_CART_REQUEST,
    CAC_ADDRESS_VALIDATION_RESULT,
    CAC_CLEAR_RESET_APP_REQUESTED,
    CAC_DUPLICATE_CUSTOM_CARD,
    CAC_EDIT_CARD_REQUESTED,
    CAC_PRESET_CUSTOM_CARD,
    CAC_REMOVE_CARD_REQUESTED,
    CAC_REQUEST_NEXT_STEP,
    CAC_RESET_ADDRESS_VALIDATION_RESULT,
    CAC_RESET_APP,
    CAC_RESET_APP_REQUESTED,
    CAC_RESET_CUSTOM_CARD,
    CAC_RESET_EDIT_CARD_REQUESTED,
    CAC_SAVE_CUSTOM_CARDS,
    CAC_SET_ADDING_TO_CART,
    CAC_SET_AVAILABLE_CARD_NETWORKS,
    CAC_SET_CARD_NETWORK,
    CAC_SET_CART_ERRORS,
    CAC_SET_CONFIG,
    CAC_SET_OCCASION_SLUG,
    CAC_UPDATE_BACKGROUND,
    CAC_UPDATE_CUSTOM_CARD,
    CAC_VALIDATE_ADDRESS_REQUEST,
    CAC_VALIDATE_ADDRESS_RESPONSE,
} from '../actions/createACard'
import CustomCard from '../components/Models/CustomCard'
import isEmpty from 'lodash/isEmpty'

export const initialState = {
    baseConfig: {},
    baseUrl: '',
    siteName: '',
    faqUrl: '',
    carrierImageUrl: '',
    carrierImageWithCardUrl: '',
    imageGuidelinesUrl: '',
    includeShipping: true,
    availableCardNetworks: [],
    availableShippingMethods: [],
    cardNetwork: {
        name: '',
        image: '',
    },
    occasionSlug: '',
    customCard: new CustomCard(),
    addingToCart: false,
    addToCartRequested: false,
    cartErrors: [],
    nextStepRequested: false,
    resetAppRequested: false,
    resetCards: false,
    editCardRequest: null,
    removeCardId: null,
    duplicateCardId: null,
    cards: [],
    canAddCards: true,
    maxQuantity: 20,
    addressChecked: false,
    addressValidationResponse: {},
    addressValidationResult: {},
    addressValidationFailed: false,
}

export default function createACardReducer(state = initialState, action) {
    switch (action.type) {
        case CAC_SET_CONFIG:
            return {
                ...state,
                baseConfig: action.payload.baseConfig,
                baseUrl: action.payload.baseUrl,
                siteName: action.payload.siteName,
                faqUrl: action.payload.faqUrl,
                carrierImageUrl: action.payload.carrierImageUrl,
                carrierImageWithCardUrl: action.payload.carrierImageWithCardUrl,
                imageGuidelinesUrl: action.payload.imageGuidelinesUrl,
                includeShipping: action.payload.includeShipping,
                availableShippingMethods:
                    action.payload.availableShippingMethods,
            }
        case CAC_SET_AVAILABLE_CARD_NETWORKS:
            return {
                ...state,
                availableCardNetworks: action.payload,
                cardNetwork: isEmpty(state.customCard.cardNetwork)
                    ? action.payload[0]
                    : state.customCard.cardNetwork,
                customCard: {
                    ...state.customCard,
                    cardNetwork: action.payload[0],
                },
            }
        case CAC_SET_CARD_NETWORK:
            return {
                ...state,
                cardNetwork: action.payload,
                customCard: {
                    ...state.customCard,
                    cardNetwork: action.payload,
                },
            }
        case CAC_SET_OCCASION_SLUG:
            return {
                ...state,
                occasionSlug: action.payload,
            }
        case CAC_UPDATE_CUSTOM_CARD:
            return {
                ...state,
                customCard: action.payload,
            }
        case CAC_EDIT_CARD_REQUESTED:
            return {
                ...state,
                editCardRequest: {
                    cardId: action.payload.cardId,
                    step: action.payload.step,
                },
                addressValidationFailed: false,
                addressValidationResult: null,
                addressChecked: false,
            }
        case CAC_RESET_EDIT_CARD_REQUESTED:
            return {
                ...state,
                editCardRequest: null,
            }
        case CAC_REMOVE_CARD_REQUESTED:
            return {
                ...state,
                removeCardId: action.payload,
            }
        case CAC_RESET_CUSTOM_CARD:
            return {
                ...state,
                customCard: new CustomCard(),
                cartErrors: [],
            }
        case CAC_RESET_APP:
            return {
                ...state,
                customCard: new CustomCard(),
                cards: [],
                cartErrors: [],
                canAddCards: true,
                addressValidationFailed: false,
                addressValidationResult: null,
                addressChecked: false,
            }
        case CAC_RESET_APP_REQUESTED:
            return {
                ...state,
                resetAppRequested: true,
                clearCards: action.payload,
                addressValidationFailed: false,
                addressValidationResult: null,
                addressChecked: false,
                addingToCart: false,
            }
        case CAC_CLEAR_RESET_APP_REQUESTED:
            return {
                ...state,
                resetAppRequested: false,
            }
        case CAC_UPDATE_BACKGROUND:
            return {
                ...state,
                customCard: {
                    ...state.customCard,
                    cloudinaryId: action.payload.cloudinaryId,
                    // previewImage: action.payload.previewImage,
                    // compositeBackgroundImage:
                    //     action.payload.compositeBackgroundImage,
                },
            }
        case CAC_REQUEST_NEXT_STEP:
            return {
                ...state,
                nextStepRequested: action.payload,
            }
        case CAC_SET_CART_ERRORS:
            return {
                ...state,
                cartErrors: action.payload,
                addingToCart: false,
            }
        case CAC_SET_ADDING_TO_CART:
            return {
                ...state,
                addingToCart: action.payload,
            }
        case CAC_ADD_TO_CART_REQUEST:
            return {
                ...state,
                addToCartRequested: action.payload,
            }
        case CAC_ADD_CUSTOM_CARD:
            return {
                ...state,
                cards: state.cards.concat(action.payload),
                customCard: new CustomCard(),
            }
        case CAC_SAVE_CUSTOM_CARDS:
            return {
                ...state,
                cards: action.payload,
            }
        case CAC_PRESET_CUSTOM_CARD:
            return {
                ...state,
                customCard: action.payload,
            }
        case CAC_DUPLICATE_CUSTOM_CARD:
            return {
                ...state,
                duplicateCardId: action.payload,
            }
        case CAC_VALIDATE_ADDRESS_REQUEST:
            return {
                ...state,
                addressChecked: true,
                addressValidationFailed: false,
            }
        case CAC_VALIDATE_ADDRESS_RESPONSE:
            if (action.error) {
                return {
                    ...state,
                    addressValidationFailed: true,
                    addressValidationResponse: null,
                }
            }
            return {
                ...state,
                addressValidationResponse: action.payload,
                addressValidationFailed: false,
            }
        case CAC_ADDRESS_VALIDATION_RESULT:
            return {
                ...state,
                addressValidationResult: action.payload,
                addressValidationResponse: null,
            }
        case CAC_RESET_ADDRESS_VALIDATION_RESULT:
            return {
                ...state,
                addressValidationResult: null,
            }
        default:
            return state
    }
}
